import { BOAT, SHORE, parseLbsOz } from './cfsa-data';

const normalizeSpeciesKey = (value) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\blesser spotted dogfish\b/g, 'l.s.d.')
    .replace(/\bl\.?\s*s\.?\s*d\.?\b/g, 'l.s.d.')
    .replace(/smooth hound \(st\)#?/g, 'smooth hound (st)')
    .replace(/\s+/g, ' ')
    .replace(/\(\s*/g, '(')
    .replace(/\s*\)/g, ')')
    .replace(/\s*\/\s*/g, '/')
    .replace(/\s*-\s*/g, '-')
    .replace(/[“”"]/g, '')
    .replace(/[‘’']/g, '')
    .replace(/[^a-z0-9()/. -]+/g, ' ')
    .replace(/\s+/g, ' ')
    .replace(/[()]/g, '')
    .trim();
  return normalized;
};

const BOAT_SPECIES_BY_KEY = Object.fromEntries(
  BOAT.map((record) => [normalizeSpeciesKey(record.species), record])
);
const SHORE_SPECIES_BY_KEY = Object.fromEntries(
  SHORE.map((record) => [normalizeSpeciesKey(record.species), record])
);

function getSpeciesRecord(location, species) {
  const key = normalizeSpeciesKey(species);
  return location === 'boat' ? BOAT_SPECIES_BY_KEY[key] : SHORE_SPECIES_BY_KEY[key];
}

export function calcPct(species, location, kg, target = 's', maxPct = null) {
  const record = getSpeciesRecord(location, species);
  if (!record) return null;

  const targetField = target === 'od' ? 'odLbs' : 'sLbs';
  const targetLbs = parseLbsOz(record[targetField]);
  if (!targetLbs) return null;

  const pct = (kg * 2.20462 / targetLbs) * 100;
  if (maxPct == null) return pct;
  return Math.min(pct, maxPct);
}
